// File: src/app/context/SearchContext.tsx

"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';
interface SearchContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  clearSearchTerm: () => void;
}
const SearchContext = createContext<SearchContextType | undefined>(undefined);
export const SearchProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const clearSearchTerm = () => setSearchTerm('');
  return <SearchContext.Provider value={{
    searchTerm,
    setSearchTerm,
    clearSearchTerm
  }} data-sentry-element="unknown" data-sentry-component="SearchProvider" data-sentry-source-file="SearchContext.tsx">
            {children}
        </SearchContext.Provider>;
};
export const useSearch = (): SearchContextType => {
  const context = useContext(SearchContext);
  console.log("useSearch invoked", context);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};